import React, { useState, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import ErpTemplate from '../../components/ErpTemplate';
import api from '../../services/api';
import { extract } from '../../util/util';
import { QRCodeCanvas } from 'qrcode.react';
import { FaDownload } from 'react-icons/fa';
import { FinField, FinTextarea } from '../../components/FinField';
import '../../css/financeiro-parcela-pagar.css';

const URL_CLIENTE = process.env.REACT_APP_CLIENTE_URL || 'https://cliente.infoaccess-mkt.com.br';
// Lado do QR code gerado para download (px). 1024 dá ~8,6 cm a 300 dpi — sobra
// para impressão em cartaz/mesa. O QR da tela continua no tamanho padrão.
const TAMANHO_DOWNLOAD = 1024;

export default function CadastroEventoPerguntaQrCode({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const nomeEmpresa = localStorage.getItem("nomeEmpresa");
    const token = localStorage.getItem('token');

    const [dados, setDados] = useState({
        empresa: empresa,
        nomeEmpresa: nomeEmpresa
    });
    const [salvando, setSalvando] = useState(false);

    const QRCODES = [
        { chave: 'registrar', titulo: 'Registrar nova pergunta', url: URL_CLIENTE + '/cadastroEventoPergunta/' + id },
        { chave: 'moderacao', titulo: 'Moderação das perguntas', url: URL_CLIENTE + '/eventoPerguntaModeracao/' + id },
        { chave: 'lista', titulo: 'Lista de Perguntas', url: URL_CLIENTE + '/eventoPerguntaAprovada/' + id },
    ];
    // QRCodeCanvas (qrcode.react 3.x) é function component e não encaminha ref,
    // então guardamos o wrapper e pegamos o <canvas> por querySelector.
    const boxDownload = useRef({});

    // Baixa o QR em .jpg. JPEG não tem transparência, então o fundo é pintado de
    // branco antes do desenho — sem isso o Chrome preenche com preto.
    const baixarQrCode = (item) => {
        const box = boxDownload.current[item.chave];
        const origem = box ? box.querySelector('canvas') : null;
        if (!origem) {
            toast.error('QR Code ainda não foi gerado, tente novamente em instantes');
            return;
        }
        const destino = document.createElement('canvas');
        destino.width = origem.width;
        destino.height = origem.height;
        const ctx = destino.getContext('2d');
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(0, 0, destino.width, destino.height);
        ctx.drawImage(origem, 0, 0);

        const link = document.createElement('a');
        link.href = destino.toDataURL('image/jpeg', 0.95);
        link.download = 'qrcode-' + item.chave + '-' + id + '.jpg';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const buscar = () => {
        if (id) {
            api({
                method: "get",
                action: '/evento/' + id,
                token: token,
            }).then(response => {
                //extrai dados internos para o array principal
                var dadosRecebidos = extract({
                    jsonLaravel: response.data.data,
                    chaves: [
                        'diretorresponsavel',
                        'cliente',
                        'empresa',
                        'municipio',
                        'pais',
                        'modelotermoaceite',
                        'modelocontrato',
                        'modeloemailconvite',
                        'modelocartaconvite',
                        'modelocarta',
                        'coordenadorrsvp',
                    ]
                });
                setDados(dadosRecebidos);
            }).catch(err => {
                //console.log(err)
            });
        }//if id
    };

    // Salva apenas a mensagem exibida ao participante. O PUT /evento aplica
    // only($fillable) sobre o que for enviado, então o payload parcial não
    // toca em nenhum outro campo do evento.
    const salvarMensagem = () => {
        setSalvando(true);
        api({
            method: 'put',
            action: '/evento/' + id,
            token: token,
            data: { mensagemPergunta: dados.mensagemPergunta ?? '' },
        }).then(() => {
            toast.success("Mensagem salva com sucesso!");
        }).catch(error => {
            toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
        }).finally(() => {
            setSalvando(false);
        });
    };

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">QrCodes</h1></div>
                </div>

                <div className="fin-pp__card" style={{ padding: 24, marginBottom: 16 }}>
                    <div className="fin-pp__cphead" style={{ marginBottom: 12 }}>
                        <h2 className="fin-pp__cphead-title">Mensagem para o participante</h2>
                        <span className="fin-pp__cphead-sub">
                            Aparece na tela de registro de pergunta, acima do formulário. Deixe em branco para não exibir nada.
                        </span>
                    </div>
                    <div className="fin-pp__filters">
                        <FinField label="Mensagem" full>
                            <FinTextarea
                                rows={4}
                                value={dados.mensagemPergunta ?? ''}
                                onChange={e => setDados({ ...dados, mensagemPergunta: e.target.value })}
                                placeholder="Ex.: Informe seu telefone para que possamos retornar caso sua pergunta não seja respondida ao vivo."
                            />
                        </FinField>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 12 }}>
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--primary"
                            onClick={salvarMensagem}
                            disabled={salvando}
                        >
                            {salvando ? 'Salvando...' : 'Salvar mensagem'}
                        </button>
                    </div>
                </div>

                <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                    {QRCODES.map(item => (
                        <div key={item.chave} className="fin-pp__card" style={{ padding: 24, flex: '1 1 260px', minWidth: 260, display: 'flex', flexDirection: 'column' }}>
                            <div className="fin-pp__cphead" style={{ marginBottom: 12 }}>
                                <h2 className="fin-pp__cphead-title">{item.titulo}</h2>
                            </div>
                            <QRCodeCanvas value={item.url} />
                            <p className="fin-pp__subtitle" style={{ marginTop: 8, wordBreak: 'break-all', flex: 1 }}>
                                {item.url}
                            </p>
                            <button
                                type="button"
                                className="fin-pp__btn fin-pp__btn--sm"
                                style={{ marginTop: 12, alignSelf: 'flex-start' }}
                                onClick={() => baixarQrCode(item)}
                            >
                                <FaDownload size={13} /> Baixar .jpg
                            </button>
                        </div>
                    ))}
                </div>

                {/* Cópia em alta resolução usada só pelo download — fica fora da tela.
                    includeMargin garante a zona de silêncio, sem ela o QR impresso falha na leitura. */}
                <div aria-hidden="true" style={{ position: 'absolute', left: '-10000px', top: 0, width: 0, height: 0, overflow: 'hidden' }}>
                    {QRCODES.map(item => (
                        <div key={item.chave} ref={el => { boxDownload.current[item.chave] = el; }}>
                            <QRCodeCanvas
                                value={item.url}
                                size={TAMANHO_DOWNLOAD}
                                includeMargin={true}
                                bgColor="#FFFFFF"
                                fgColor="#000000"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </ErpTemplate>
    );
}
